export function afterPageRender(callback) {
  requestAnimationFrame(() => {
    requestAnimationFrame(callback)
  })
}
